export default function CapacityHelp({ onClose, style }) {
  return (
    <div className="ne-help" style={style}>
      <div className="ne-help-head">
        <span>How this works</span>
        <button className="ne-help-close" onClick={onClose} title="Close">×</button>
      </div>

      <h4>A truck takes more road than a car</h4>
      <p>
        So a lane does not carry a flat 1,800 vehicles an hour. Capacity is
        discounted by the mix of vehicles using the road, the way the{' '}
        <b>Highway Capacity Manual</b> does it.
      </p>
      <p className="ne-help-formula">
        f<sub>HV</sub> = 1 / [1 + Σ P<sub>i</sub> × (pce<sub>i</sub> − 1)]<br />
        capacity = lanes × 1800 × f<sub>HV</sub>
      </p>
      <p>
        P<sub>i</sub> is each vehicle type's share of that road's traffic, and{' '}
        pce<sub>i</sub> is how much road it takes compared with a car.
      </p>

      <h4>Where the pce comes from</h4>
      <p>
        Each vehicle type in the mix carries a fixed <code>pce</code>. The HCM
        counts a vehicle as heavy when it runs <b>more than four tyres</b> on the
        pavement, so buses, single-unit and combination trucks, refuse trucks and
        motor homes are <code>2.0</code>; motorcycles, passenger cars, passenger
        trucks and light commercial trucks are <code>1.0</code>.
      </p>
      <p>
        A metro's default mix comes from EPA 2022 vehicle miles travelled for its
        counties, passenger cars and passenger trucks only, so every vehicle is{' '}
        <code>1.0</code> and the discount is zero until heavier types are added.
      </p>

      <h4>This departs from the reference implementation</h4>
      <p>
        The project's original V/C comes from PPSforSUMO, which divides a plain
        vehicle count by lanes × 1800 — one truck, one car. Capacity is
        discounted here instead, because vehicle types that cannot move capacity
        would be a control with no effect.
      </p>

      <h4>Source</h4>
      <p>
        <a href="https://www.civil.iitb.ac.in/tvm/nptel/574_SignalLos/web/web.html"
          target="_blank" rel="noreferrer">
          NPTEL — Capacity and LOS at signalised intersections
        </a>
        , which states this for a single heavy-vehicle class at
        E<sub>T</sub> = 2.0. The form above is the same thing summed over as many
        types as the mix holds.
      </p>
    </div>
  );
}
